import { Form } from "react-bootstrap";
import styles from '../pa_checklist.module.scss';

const ChecklistRadio = (props) => {
  const { title, name, idTrue, idFalse, labelTrue, labelFalse, checked, onChangeTrue, onChangeFalse, disabled } = props;

  return (
    <div className={styles.dados_analise_divergencias} style={{justifyContent: 'left'}}>
      <label className={styles.sub_form_label} style={{ width: '50%' }}>
        <span>{title}</span>
      </label>

      <div className={styles.vertical_separator} />

      <Form.Group className={styles.flex_options}>
        <Form.Check
          name={name}
          id={idTrue}
          type={'radio'}
          label={labelTrue}
          checked={checked === true}
          onChange={onChangeTrue}
          style={{ transform: 'scale(1.1)' }}
          disabled={disabled}
        />
        <Form.Check
          name={name}
          id={idFalse}
          type={'radio'}
          label={labelFalse}
          checked={checked === false}
          onChange={onChangeFalse}
          style={{ transform: 'scale(1.1)' }}
          disabled={disabled}
        />
      </Form.Group>
    </div>
  );
}

export default ChecklistRadio;
